;(function () {

"use strict";

var ConfigureConfigFormView = require('../views/configure-config-form');

var PageView = Backbone.View.extend({
  initialize: function () {
    console.log('init configure object config view');

    window.Buttons = {
      primary: {
        label: "Save Configuration",
        message: 'config_form_submit',
        loading: true,
        callback: function (message, data) {
          window.App.Events.trigger('submit');
        }
      }
    };

    new ConfigureConfigFormView({ el: this.$el.find('form'), objectConfig: true });
  }
});

module.exports = PageView;

}());